import { useState, Dispatch, SetStateAction } from 'react'

export const useStateWithReset = <T>(
    initialState: T
): [T, Dispatch<SetStateAction<T>>, () => void, boolean] => {
    const [state, setState] = useState<T>(initialState)

    return [
        state as T,
        setState as Dispatch<SetStateAction<T>>,
        () => setState(initialState),
        state !== initialState, // Warning: may not work for all object types <3
    ]
}
